import i18n from "../../plugins/I18nPlugin";

export function folderPathRule(
  message = "objects.document.folderPathInvalid"
): (value: any) => boolean | string {
  return (value) => {
    if (!value) return true;
    return /^(\/|(?:\/[a-zA-Z0-9_-]+\/?)+)$/.test(value) || String(i18n.tc(message));
  };
}
